export default {

    state: {
        dataAcompanhamentoProtesto: new Date()
    },

    mutations: {
        setDataAcompanhamentoProtesto(state, payload) {
            state.dataAcompanhamentoProtesto = payload;
        }
    },

    getters: {
        getDataAcompanhamentoProtesto(state) {
            return state.dataAcompanhamentoProtesto;
        }
    },

    actions: {
        setDataAcompanhamentoProtesto({commit}, dataAcompanhamentoProtesto) {
            commit('setDataAcompanhamentoProtesto', dataAcompanhamentoProtesto);
        }
    }
}